export interface ISdVoteDto {
    hasCommented: boolean;
    hasDocument: boolean;
    hasHistories: boolean;
    lastUpdated: Date;
    ballotRecordId: number;
    ballotVoteId: number;
    publicationId: string;
    committeeMember: string;
    country: string;
    email: string;
    organisation: string;
    role: string;
    voteId: string;
    vote: string;
    submitted?: Date;
    isEligible: boolean;
    votingRight: string;
    comment: string;
    isCoa: boolean;
    weight: number;
}

export interface ISubmitSdBallotVoteRequest {
  ballotId: number;
  voteResult: string;
  pmRemarks?: string;
  ballotComment?: string;
  ballotVoteId: number;
  isCOA: boolean;
}
export interface ISdBallotVoteHistory {
  id: number;
  voteResult: string;
  lastUpdated: Date;
  ballotComment: string;
  isCOA: boolean;
}

export const RegulatoryAndControllingBodiesVote = "Regulatory and Controlling Bodies";

export const RegulatoryAndControllingBodiesVoteWeight = 0.25;

export const RegulatoryAndControllingBodiesVoteCommittee = "EL-001";



